module.exports = __webpack_public_path__ + "img/header_strom.8b5f1f84.jpg";